<template>
  <!--title start-->
  <div>
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>  {{ $t("researchfield") }}</h4>
        </div>
        <ul id="myTab" class="depth_3">
          <li role="presentation" v-bind:class="{active:tabIndex==0}" style="width: 33.3%">
            <a v-on:click="tabIndex=0" id="tab0-btn" role="tab" data-toggle="tab" aria-expanded="true">{{ $t("researchfield_title_1") }}</a>
          </li>
          <li role="presentation" v-bind:class="{active:tabIndex==1}" style="width: 33.3%">
            <a v-on:click="tabIndex=1" id="tab1-tab" role="tab" data-toggle="tab" aria-expanded="false">{{ $t("researchfield_title_2") }} </a>
          </li>
          <li role="presentation" v-bind:class="{active:tabIndex==2}" style="width: 33.3%">
            <a v-on:click="tabIndex=2" id="tab2-tab" role="tab" data-toggle="tab" aria-expanded="false">{{ $t("researchfield_title_3") }}</a>
          </li>
        </ul>
      </div>
    </div>

    <!--content start-->
    <div class="grab h4wrap">
      <!--part1-->
      <div  class="tab-pane" v-if="tabIndex==0">
        <div class="border_dashed_b">
          <h5 class="h5_title">{{ $t("MajorResearchContents") }}</h5>
          <h6 class="h6_title">{{ $t("field_1_1_title") }}</h6>
          <ul class="ul_list">
            <li>{{ $t("field_1_1_detail_1") }}</li>
            <li>{{ $t("field_1_1_detail_2") }}</li>
          </ul>
          <div class="field_image"><img src="/static/img/field_1_1.jpg"></div>
        </div>
        <div class="border_dashed_b">

          <h6 class="h6_title" style="margin-top: 20px">{{ $t("field_1_2_title") }}</h6>
          <ul class="ul_list">
            <li>{{ $t("field_1_2_detail_1") }}</li>
            <li>{{ $t("field_1_2_detail_2") }}</li>
            <li>{{ $t("field_1_2_detail_3") }}</li>
          </ul>
        </div>
        <div class="border_dashed_b">
          <h6 class="h6_title" style="margin-top: 20px">{{ $t("field_1_3_title") }}</h6>
          <ul class="ul_list">
            <li>{{ $t("field_1_3_detail_1") }}</li>
            <li>{{ $t("field_1_3_detail_2") }}</li>
            <li>{{ $t("field_1_3_detail_3") }}</li>
          </ul>
          <div class="field_image"><img src="/static/img/field_1_2.jpg"></div>
        </div>
      </div>

      <!--part2-->
      <div  class="tab-pane" v-if="tabIndex==1">
        <div class="border_dashed_b">
          <h5 class="h5_title">{{ $t("MajorResearchContents") }}</h5>
          <p>{{ $t("field_2_detail_1") }}</p>
          <p>{{ $t("field_2_detail_2") }}</p>
          <h6 class="h6_title" style="margin-top: 20px">{{ $t("field_2_1_title") }}</h6>
          <ul class="ul_list">
            <li><p>{{ $t("field_2_1_detail_1") }}</p>
              <div>{{ $t("field_2_1_detail_1_detail") }}</div>
            </li>
            <li><p>{{ $t("field_2_1_detail_2") }}</p>
              <div><p>{{ $t("field_2_1_detail_2_detail_1") }}</p>
                <p>{{ $t("field_2_1_detail_2_detail_2") }}</p></div>
            </li>
          </ul>
          <div class="field_image"><img src="/static/img/field_2_1.jpg"></div>
        </div>

        <div class="border_dashed_b">
          <h6 class="h6_title" style="margin-top: 20px">{{ $t("field_2_2_title") }}</h6>
          <ul class="ul_list">
            <li><p>{{ $t("field_2_2_detail") }}</p>
              <div><p>{{ $t("field_2_2_detail_1") }}</p>
                <p>{{ $t("field_2_2_detail_2") }}</p>
              </div>
            </li>
          </ul>
          <div class="field_image"><img src="/static/img/field_2_2.jpg"></div>
        </div>

        <div class="border_dashed_b">
          <h6 class="h6_title" style="margin-top: 20px">{{ $t("field_2_3_title") }}</h6>
          <ul class="ul_list">
            <li><p>{{ $t("field_2_3_detail") }}</p>
              <div>{{ $t("field_2_3_detail_1") }}</div>
            </li>
          </ul>
          <div class="field_image"><img src="/static/img/field_2_3.jpg"></div>
        </div>

        <div class="border_dashed_b">
          <h6 class="h6_title" style="margin-top: 20px">{{ $t("field_2_4_title") }}</h6>
          <ul class="ul_list">
            <li><p>{{ $t("field_2_4_detail") }}</p>
              <div>{{ $t("field_2_5_detail_1") }}</div>
            </li>
          </ul>
          <div class="field_image"><img src="/static/img/field_2_4.jpg"></div>
        </div>
        </div>

      <!--part3-->
      <div  class="tab-pane" v-if="tabIndex==2">
        <div class="border_dashed_b">
          <h5 class="h5_title">{{ $t("MajorResearchContents") }}</h5>
          <h6 class="h6_title" style="margin-top: 20px">{{ $t("field_3_1_title") }}</h6>
          <ul class="ul_list">
            <li><p>{{ $t("field_3_1_detail_1") }}</p>
              <div>{{ $t("field_3_1_detail_1_detail") }}</div>
              <div>{{ $t("field_3_1_detail_2_detail") }}</div>
              <div>{{ $t("field_3_1_detail_3_detail") }}</div>
              <div>{{ $t("field_3_1_detail_4_detail") }}</div>
            </li>
          </ul>
          <div class="field_image"><img src="/static/img/field_3_1.jpg"></div>
          <ul class="ul_list">
            <li><p>{{ $t("field_3_2_detail_1") }}</p>
              <div>{{ $t("field_3_2_detail_1_detail") }}</div>
            </li>
          </ul>
          <div class="field_image"><img src="/static/img/field_3_2.jpg"></div>
        </div>
      </div>

    </div>
  </div>


</template>

<script>
  import Image from '../editor/modules/image'

  export default {
    components: {Image},
    name: 'ResearchField',
    data: function () {
      return {
        msg:0
      }
    },
    props: {
      tabIndex: {default: 0}
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/ResearchField.vue